@if(question) {
  @for (opt of question.options; track opt.key) {
    <span>
    <input [id]="opt.key + question.key + question.payload" [attr.name]="opt.key + question.key + question.payload"
           type="radio" class="btn-radio" [value]="opt.key" [formControlName]="question.key">
      <!--suppress XmlInvalidId -->
    <label [attr.for]="opt.key + question.key + question.payload" class="me-3">{{ opt.value }}</label>
  </span>
  }
}
